import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { TopBarSlimThemes } from '../TopBarSlimEnums';

const COPY = defineMessages({
  MESSAGE: {
    id: 'InRetryTopBarSlim.message',
    defaultMessage: 'Keep access to survey data and powerful features.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'InRetryTopBarSlim.ctaText',
    defaultMessage: 'Update Billing!',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
  BOLD_PREFIX: {
    id: 'InRetryTopBarSlim.prefix',
    defaultMessage: 'Update your billing information:',
    description: '[Type: Header][Vis.: low] - Top bar slim prefix',
  },
});

export const InRetryTopBarSlim: React.FC = () => {
  return (
    <TopBarSlim
      message={t(COPY.MESSAGE)}
      ctaText={t(COPY.CTA_TEXT)}
      ctaLink={createURL('/billing/', {
        ep: 't',
        ep_trigger: 'retry',
        ut_source: 'topbar',
        ut_source2: 'in_retry',
      })}
      theme={TopBarSlimThemes.warning}
      prefix={t(COPY.BOLD_PREFIX)}
    />
  );
};

export default InRetryTopBarSlim;
